import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CustomButtonComponent} from '../custom-button/custom-button';

@Component({
  selector: 'app-delete-confirmation-modal',
  standalone: true,
  imports: [CommonModule, CustomButtonComponent ],
  templateUrl: './delete-confirmation-modal.html',
  styleUrls: ['./delete-confirmation-modal.css']
})
export class DeleteConfirmationModalComponent implements OnInit, OnDestroy {
  @Input() isOpen: boolean = false;
  @Input() title: string = 'Eliminar usuario';
  @Input() message: string = '¿Estás seguro que desea eliminar el usuario?';
  @Input() confirmText: string = 'Eliminar';
  @Input() cancelText: string = 'Cancelar';
  @Input() loading: boolean = false;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  ngOnInit() {
    if (this.isOpen) {
      this.handleModalOpen();
    }
  }

  ngOnDestroy() {
    this.handleModalClose();
  }

  ngOnChanges() {
    if (this.isOpen) {
      this.handleModalOpen();
    } else {
      this.handleModalClose();
    }
  }

  private handleModalOpen() {
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', this.handleEscapeKey.bind(this));
  }

  private handleModalClose() {
    document.body.style.overflow = 'auto';
    document.removeEventListener('keydown', this.handleEscapeKey.bind(this));
  }

  private handleEscapeKey(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.onCancel();
    }
  }

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
    this.close.emit();
  }

  onBackdropClick(event: Event) {
    if (event.target === event.currentTarget) {
      this.onCancel();
    }
  }
}
